import React from 'react';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import DatasetFormatter from './DatasetFormatter';
import TypeFormatter from './TypeFormatter';
import StatusFormatter from './StatusFormatter';

export const batchFormatter = (cell, row) => (
  <MuiLink variant="subtitle1" component={Link} to={`/batches/${row.id}`}>
    {row.reference || '-'}
  </MuiLink>
);

export const typeFormatter = cell => <TypeFormatter data={cell} />;

export const datasetFormatter = cell => <DatasetFormatter datasetId={cell} />;

export const statusFormatter = (cell, row) => <StatusFormatter data={row} />;

export default datasetFormatter;
